import { notify } from "../components/notify";
import imageCompression from 'browser-image-compression';

import raisedIcon from '../assets/svg/raisedIcon.svg';
import approvedIcon from '../assets/svg/approvedIcon.svg';
import holdIcon from '../assets/svg/holdImg.svg';
import editTimelineIcon from '../assets/svg/editTimelineIcon.svg';
import POIcon from '../assets/svg/POGenerateIcon.svg';


export function makeTxtOverFLow(str, len) {
   if (str) {
      str = str.toString();
      if (str?.length <= len)
         return str;

      return str?.slice(0, len) + "....";
   } else {
      return ""
   }

}

export function getSrchTypeTxt(ddArr, searchType) {
   let filteredObj = ddArr.filter((i) => i.value === searchType);
   return filteredObj[0]?.label || "";
}

export function formatName(fName, lName) {
   if (fName && lName)
      return capFirstLetterOnly(`${fName} ${lName}`);
   if (fName)
      return capFirstLetterOnly(fName);
   return "";
}

export function capFirstLetterOnly(string) {
   if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
   }
   return ""
}

export function getFirstLetter(string) {
   if (string) {
      return string.charAt(0).toUpperCase();
   }
   return ""
}

export function isEmpty(val) {
   if (val === "" || val === null || val === undefined)
      return true
   return false
}

export function isNotEmpty(val) {
   if (val === "" || val === null || val === undefined)
      return false
   return true
}

export function isObjEmpty(obj) {
   return Object.keys(obj).length === 0;
}

export function formatUserType(userType) {
   switch (userType) {
      case "master_admin": return "Master Admin";
      case "admin": return "Admin";
      case "sourcing": return "Sourcing";
      case "store": return "Store";
      case "accounts": return "Accounts";
      case "line_manager": return "Contract Owner";
      case "focal_point": return "Contract Focal Point";
      case "approver": return "End User";
      case "requestor": return "Requestor";

      case "created": return "Raised";
      case "approved": return "Approved";
      case "held": return "Hold";
      case "edited": return "Edited";
      case "pogen": return "OR Generated";
      case "mailsend": return "Mail Sent";

      case "new": return "New";
      case "acknowledged": return "Acknowledged";
      case "confirmed": return "Confirmed";
      case "partially_dispatched": return "Partially Dispatched";
      case "order_completed": return "Order Completed";

      case "awaiting_post_po_clarify": return "AWAITING POST-PO CLARIFICATION";
      case "packing_in_prog": return "PACKING IN PROGRESS";
      case "material_ready": return "MATERIAL IS READY";
      case "awaiting_sdo_dhl_pickup": return "AWAITING SDO/DHL PICK-UP";
      case "back_order": return "BACK ORDER";
      case "partially_del": return "PARTIALLY DELIVERED";
      case "del_completed": return "DELIVERY COMPLETED";

      case "paid": return "PAID";
      case "unpaid": return "UNPAID";
      case "partially_paid": return "PARTIALLY PAID";
      case "na": return "NA";
      case null: return "NA";
      case "": return "NA";

      case 1: return "Approved";
      case 0: return "Pending Approval";

      default: return userType
   }
}

export async function compressImage(selectedFile) {
   if (!selectedFile)
      return;
   const options = {
      maxSizeMB: 1,          // Maximum size in MB
      maxWidthOrHeight: 500, // Maximum width or height in pixels
      useWebWorker: true,    // Use a web worker for better performance
   };
   try {
      const compressedFile = await imageCompression(selectedFile, options);
      return compressedFile;
   } catch (err) {
      notify('error', 'Error during image compression: ' + err.message);
   }
};

export function formatDateTime(dateTime) {
   if (!dateTime || dateTime === "null")
      return 'NA';

   const date = new Date(dateTime);
   // Extract day, month, and year
   const day = String(date.getDate()).padStart(2, '0');
   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
   const year = date.getFullYear();
   // Extract hours, minutes, and determine AM/PM
   let hours = date.getHours();
   const minutes = String(date.getMinutes()).padStart(2, '0');
   const ampm = hours >= 12 ? 'PM' : 'AM';
   // Convert to 12-hour format and add leading zero
   hours = String(hours % 12 || 12).padStart(2, '0');

   return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

}

export function formatDateWithJs(dateTime) {
   if (!dateTime)
      return 'NA'

   if (dateTime === "null")
      return 'NA'

   //18/9/2022
   var date = new Date(dateTime);
   let month = date.getMonth() + 1;

   return (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + '-'
      + (month < 10 ? "0" + month : month) + "-"
      + date.getFullYear()
}

export function checkNumFormat(val) {
   if (val === "" || val === undefined)
      return null

   return parseInt(val)

}

export function datePickerformat(dateTime) {
   if (!dateTime)
      return null

   //18/9/2022  yyyy-MM-dd
   var date = new Date(dateTime);
   let month = date.getMonth() + 1;

   return date.getFullYear() + "-" +
      (month < 10 ? "0" + month : month) + "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())
}

export function NumberFormatter(num) {
   if (num === "" || num === null || num === "null" || num === undefined)
      return "NA"
   try {
      // const roundedNum = parseFloat(num).toFixed(2); // Round to 2 decimal places
      const roundedNum = parseFloat(num); // Round to 2 decimal places
      return roundedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   } catch (error) {
      return num
   }
}

export function NumFormatter(num) {
   if (num === "" || num === null || num === "null" || num === undefined)
      return "NA"
   try {
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   } catch (error) {
      return num
   }
}

export function getReqTimelineStyle(status) {
   switch (status) {
      case "created": return {
         color: "rgba(33, 158, 188, 1)",
         bycolor: "rgba(33, 158, 188, 0.3)",
         icon: raisedIcon,
         status: "Raised"
      }
      case "approved": return {
         color: "rgb(143,201,58,1)",
         bycolor: "rgba(143, 201, 58, 0.3)",
         icon: `${approvedIcon}`,
         status: "Approved"
      }
      case "held": return {
         color: "rgba(219, 52, 55, 1)",
         bycolor: "rgba(219, 52, 55, 0.3)",
         icon: `${holdIcon}`,
         status: "Hold"
      }
      case "edited": return {
         color: "rgba(255, 183, 3, 1)",
         bycolor: "rgba(255, 183, 3, 0.3)",
         icon: `${editTimelineIcon}`,
         status: "Edited",
      }
      case "pogen": return {
         color: "rgb(7, 42, 200, 1)",
         bycolor: "rgb(7, 42, 200, 0.3)",
         icon: `${POIcon}`,
         status: "OR Generated",
      }
      case "mailsend": return {
         color: "rgb(7, 42, 200, 1)",
         bycolor: "rgb(7, 42, 200, 0.3)",
         icon: `${POIcon}`,
         status: "Mail Sent",
      }

      default:
         return {
            color: "rgba(219, 52, 55, 1)",
            bycolor: "rgba(219, 52, 55, 0.3)",
            icon: `${holdIcon}`,
            status: "Raised"
         }
   }
}

export function getPoStatusClrSx(status) {
   switch (status) {
      case "new": return {
         color: "rgba(33, 158, 188, 1)",
         bycolor: "rgba(33, 158, 188, 0.3)"
      }
      case "acknowledged": return {
         color: "rgb(143,201,58,1)",
         bycolor: "rgba(143, 201, 58, 0.3)",
      }
      case "confirmed": return {
         color: "rgba(255, 183, 3, 1)",
         bycolor: "rgba(255, 183, 3, 0.3)"
      }
      case "partially_dispatched": return {
         color: "rgb(7, 42, 200, 1)",
         bycolor: "rgb(7, 42, 200, 0.3)"
      }
      case "order_completed": return {
         color: "rgb(7, 42, 200, 1)",
         bycolor: "rgb(7, 42, 200, 0.3)"
      }

      default:
         return {
            color: "rgba(219, 52, 55, 1)",
            bycolor: "rgba(219, 52, 55, 0.3)"
         }
   }
}

export function getBalance(n1, n2, i) {
   return Number(n1) - Number(n2)
}

export function convert10(num) {
   if (num === "1" || num === 1)
      return "YES";
   else if (num === "0" || num === 0)
      return "NO";
   else
      return num;
}